<template>
  <div class="search-input" :class="{ 'show': showPanel }">
    <div class="search">
      <div class="search-box" :class="{ 'mini': !showPanel }">
        <img src="@static/images/search.png" class="search-icon">
        <input type="text" placeholder="输入投/被保险人姓名/产品名称搜索" v-model="name" @input="search" @click.stop="openPanel">
      </div>
      <span class="cancel-btn" @click="back" v-if="showPanel">取消</span>
    </div>
    <div class="list-panel" v-show="name">
      <div class="list-info" v-if="$refs.list">共搜索到<span>{{ $refs.list.listCount }}</span>条相关记录</div>
    </div>
    <orderList v-show="name" ref="list" :isOrder="isOrder" @setListParams="setListParams" @listCallback="listCallback">
    </orderList>
  </div>
</template>

<script>
import orderList from "./list"
export default {
  props: {
    isOrder: null,
    isGift: 0
  },
  components: { orderList },
  data() {
    return {
      showPanel: false,
      name: ""
    };
  },
  watch: {
    $route: {
      handler(val, oldval) {
        if (this.$route.query.showPanel == 1) {
          this.showPanel = true;
        } else {
          this.showPanel = false;
          this.name = "";
          sessionStorage.removeItem("appSearchOrderName");
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if (sessionStorage.appSearchOrderName) {
      this.name = sessionStorage.appSearchOrderName;
      this.$nextTick(() => {
        this.$refs.list.init("/api/order/queryMyOrders");
      });
    } else {
      this.listLoading = false;
      this.finished = true;
      this.finishedText = "";
    }
  },
  methods: {
    //设置参数
    setListParams(params) {
      params.keywords = this.name;
      params.isGift = this.isGift;
    },
    listCallback(res) {

    },
    back() {
      history.go(-1);
    },
    openPanel() {
      if (this.$route.query.showPanel == 1) {
        return;
      }
      this.$router.push({
        query: { showPanel: 1 }
      })
    },
    search(e) {
      if (!this.showPanel) {
        this.openPanel();
        return
      }
      this.name = e.target.value;
      sessionStorage.appSearchOrderName = this.name;
      // this.$emit("search",e);
      if (this.name) {
        this.$refs.list.init("/api/order/queryMyOrders");
      } else {
        this.$refs.list.list = [];
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./searchInput.scss";
</style>
